import { KeyValuePipe, NgClass, NgPlural, NgPluralCase } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CheckoutStore } from '@interfaces/store.interface';

import { CapitalizeFirstLetterPipe } from '../../../../shared/pipes/capitalize-first-letter.pipe';
import { DataCyDirective } from '../../../directives/data-cy.directive';
import { DataCsMaskDirective } from '../../../directives/data-mask.directive';
import { OpeningHourLineComponent } from './opening-hour-line/opening-hour-line.component';

@Component({
    selector: 'checkout-store',
    templateUrl: './store.component.html',
    styleUrl: 'store.component.scss',
    standalone: true,
    imports: [
        DataCyDirective,
        NgClass,
        DataCsMaskDirective,
        KeyValuePipe,
        CapitalizeFirstLetterPipe,
        NgPlural,
        NgPluralCase,
        OpeningHourLineComponent,
    ],
})
export class StoreComponent {
    // Allows generic props for template no matter what the store is
    @Input() public store: CheckoutStore;
    @Input() public isSelected: boolean;
    @Input() public isLast: boolean;
    @Input() public isStandAlone: boolean;
    @Input() public shouldAvoidScrollDelay: boolean = false;
    @Output() selectStoreEvent: EventEmitter<CheckoutStore> = new EventEmitter<CheckoutStore>();

    public showHours: boolean;
    public currentDay: number = new Date().getDay();

    public selectStore(): void {
        this.selectStoreEvent.emit(this.store);
        this.showHours = true;
    }
}
